module.exports = __webpack_public_path__ + "img/market.4a5bdd0c.jpg";